import React from "react";
import "./svg.css";
const ThumbUp = ({ width, height }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 244 232"
      style={{ enableBackground: "new 0 0 244 232" }}
      width={width}
      height={height}
    >
      <circle className="st0" cx="118" cy="114" r="100" />
      <g>
        <path
          className="st1"
          d="M86.1,152.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5S89.6,152.5,86.1,152.5z M86.1,160.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S86.9,160.5,86.1,160.5z"
        />
        <path
          className="st1"
          d="M162.1,127.1c-0.2-0.2-0.2-0.3-0.2-0.3c0-0.1,0.1-0.2,0.1-0.2c0.2-0.2,0.3-0.3,0.4-0.6c2.2-4.4,1.3-7.5,0.1-9.3c-4.7-7.1-21.4-6.4-23.3-6.3c-0.2,0-0.4,0-0.6,0.1c-0.7,0.2-3,0.6-4-0.5c-0.7-0.7-2-3.3,0.7-11.5c3-8.9,2.7-15.6-0.9-19.9c-3.2-3.9-8.1-4.4-10.2-4.2c-2,0.2-5.3,2.3-5.4,12.8c-1,2.5-6.2,15.2-9.8,22.6c-2,4.3-5.8,6.1-8.4,7v-1.4c0-3.8-3.1-7-7-7H77.7c-3.8,0-7,3.1-7,7v50.7c0,3.8,3.1,7,7,7h15.9c3.8,0,7-3.1,7-7V166c4.4,2.9,9.1,6,10,6.6c1.3,0.9,6.4,1.4,12.7,1.4c8.6,0,19.2-0.9,25.1-2.6c9.7-2.9,10.3-10.6,10-14.5c1.9-1,3.3-2.5,4.1-4.3c1.7-3.7,1-8.1,0.3-10.4c1.4-1.5,2.2-3.4,2.4-5.6C165.5,132.6,163.8,128.8,162.1,127.1z M95.6,166.1c0,1.1-0.9,2-2,2H77.7c-1.1,0-2-0.9-2-2v-50.7c0-1.1,0.9-2,2-2h15.9c1.1,0,2,0.9,2,2V166.1z M160.2,136.1c-0.1,1.4-0.7,2.5-1.7,3.2c-1,0.7-1.3,1.9-0.9,3c0.5,1.4,1.7,5.5,0.4,8.2c-0.6,1.2-1.6,2-3.1,2.5c-1.3,0.4-2,1.7-1.7,3c0.2,0.8,1.8,8.2-6.3,10.6c-9.8,2.9-30.4,2.7-33.6,1.8c-1.9-1.4-9.7-6.4-12.8-8.4v-37.9c3.2-0.8,9.6-3,13-10c4-8.4,10-23.2,10.1-23.3c0.1-0.3,0.2-0.6,0.2-0.9c0-3.5,0.6-7.3,1.3-8.3c1.1,0,3.7,0.3,5.4,2.4c2.3,2.9,2.3,8.1,0,15.2c-2.7,8.1-2.6,13.5,0.4,16.6c2.6,2.6,6.6,2.5,8.8,1.9c5.2-0.3,16.1,0.4,18.5,4c0.2,0.4,1,1.5-0.3,4.1c-1.2,1.6-2,4.7,0.7,7.2C159.3,131.4,160.4,133.8,160.2,136.1z"
        />
        <path
          className="st1"
          d="M98.1,87.1h10.4c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5H98.1c-1.4,0-2.5,1.1-2.5,2.5S96.7,87.1,98.1,87.1z"
        />
        <path
          className="st1"
          d="M112.9,73.3c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.8-0.7c1-1,1-2.6,0-3.5l-6.2-6.2c-1-1-2.6-1-3.5,0c-1,1-1,2.6,0,3.5L112.9,73.3z"
        />
        <path
          className="st1"
          d="M127.3,71c1.4,0,2.5-1.1,2.5-2.5V56.6c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v11.9C124.8,69.8,125.9,71,127.3,71z"
        />
        <path
          className="st1"
          d="M140.1,74.3c0.6,0,1.3-0.2,1.8-0.7l6.8-6.8c1-1,1-2.6,0-3.5c-1-1-2.6-1-3.5,0l-6.8,6.8c-1,1-1,2.6,0,3.5C138.8,74,139.4,74.3,140.1,74.3z"
        />
        <path
          className="st1"
          d="M143.2,84.6c0,1.4,1.1,2.5,2.5,2.5h11.2c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5h-11.2C144.3,82.1,143.2,83.2,143.2,84.6z"
        />
      </g>
    </svg>
  );
};
export default ThumbUp;
